<template>
  <footer>
    <div class="l-container footer-container">
      <FooterMenu :categories="categories" />
      <div class="bottom">
        <FooterColumn
          v-bind="company"
          :key="!isMobile + 'company'"
          :is-mobile="isMobile"
          :is-open="!isMobile || isMoreMobile"
          :is-disable-click="!isMobile"
          @click="sendAnalitics($event.target)"
        >
        </FooterColumn>
        <FooterColumn
          v-bind="consumer"
          :key="!isMobile + 'consumer'"
          :is-mobile="isMobile"
          :is-open="!isMobile || isMoreMobile"
          :is-disable-click="!isMobile"
          @click="sendAnalitics($event.target)"
        >
        </FooterColumn>
        <FooterColumn
          v-bind="shops"
          :key="!isMobile + 'shops'"
          :is-mobile="isMobile"
          :is-open="!isMobile || isMoreMobile"
          :is-disable-click="!isMobile"
          @click="sendAnalitics($event.target)"
        />
        <FooterColumn
          v-bind="partners"
          :key="!isMobile + 'partners'"
          :is-mobile="!isMobile"
          :is-open="!isMobile || isMoreMobile"
          :is-disable-click="!isMobile"
          @click="sendAnalitics($event.target)"
        />
      </div>
      <div class="copyright body-l-regular">
        <div class="copyright-left-group">
          <nuxt-link class="copyright-item" to="/legal/">
            <span>Правовая информация</span>
          </nuxt-link>
          <nuxt-link
            class="copyright-item"
            to="https://static.price.ru/docs/PriceExpressPersonalDataPolicy.pdf"
          >
            <span>Политика обработки ПДн</span>
          </nuxt-link>
        </div>

        <div class="copyright-item date-company">
          <span
            >© 1997 — {{ actualYear }}&nbsp;, ООО&nbsp;&laquo;Прайс
            Экспресс&raquo;</span
          >
          <svg
            class="age"
            width="29"
            height="20"
            viewBox="0 0 29 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="28.1667" height="20" rx="3.33333" fill="#86888F" />
            <path
              d="M5.61301 15V7.53333H3.41301V6.58667C4.81301 6.53333 5.50634 6.38667 6.01301 5.33333H7.01301V15H5.61301ZM15.6171 7.62667C15.6171 8.44 15.2571 9.33333 14.3371 9.85333C15.5371 10.3867 15.9104 11.3733 15.9104 12.2667C15.9104 14.1333 14.3637 15.1733 12.3504 15.1733C10.3371 15.1733 8.7904 14.1333 8.7904 12.2667C8.7904 11.3733 9.17707 10.3867 10.3771 9.85333C9.4704 9.34667 9.09707 8.44 9.09707 7.62667C9.09707 6.2 10.3504 5.16 12.3504 5.16C14.3504 5.16 15.6171 6.2 15.6171 7.62667ZM12.3504 6.26667C11.2304 6.26667 10.4704 6.86667 10.4704 7.8C10.4704 8.74667 11.2304 9.42667 12.3504 9.42667C13.4837 9.42667 14.2304 8.74667 14.2304 7.8C14.2304 6.86667 13.4837 6.26667 12.3504 6.26667ZM10.2571 12.24C10.2571 13.36 11.0704 14.0533 12.3504 14.0533C13.6304 14.0533 14.4571 13.36 14.4571 12.24C14.4571 11.1333 13.6304 10.4 12.3504 10.4C11.0704 10.4 10.2571 11.1333 10.2571 12.24Z"
              fill="#242424"
            />
            <rect
              x="20.875"
              y="6.6665"
              width="1.25"
              height="6.66667"
              fill="#242424"
            />
            <rect
              x="18.167"
              y="10.625"
              width="1.25"
              height="6.66667"
              transform="rotate(-90 18.167 10.625)"
              fill="#242424"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-if="showTop" :class="['go-top', { show: showTop }]" @click="goTop">
      <span class="slider_triangle slider_triangle--top">
        <span class="slider_triangle__elem" />
      </span>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core';
import { useMediaQueryStore } from '~/stores/mediaQuery';

const mediaStore = useMediaQueryStore();
const isMobile = computed(() => mediaStore.isLessEs || mediaStore.isEs);
const isMoreMobile = computed(
  () =>
    mediaStore.isSm ||
    mediaStore.isMd ||
    mediaStore.isLg ||
    mediaStore.isXl ||
    mediaStore.isXXl ||
    mediaStore.isXMax
);

const { $ymAnyEvent } = useNuxtApp();
const footer1 = 'footer-1';
const footer2 = 'footer-2';
const footer3 = 'footer-3';
const footer5 = 'footer-5';
const footer6 = 'footer-6';
const footer7 = 'footer-7';
const footer8 = 'footer-8';
const showTop = ref<boolean>(false);
const isShowTop = () =>
  (showTop.value =
    window.scrollY / (document.body.offsetHeight - window.innerHeight) > 0.5);

const categories = computed(() => [
  {
    name: 'Электроника',
    icon: footer1,
    link: '/portativnaya-tehnika/',
  },
  {
    name: 'Бытовая техника',
    icon: footer2,
    link: '/bytovaya-tehnika/',
  },
  {
    name: 'Для автомобиля',
    icon: footer3,
    link: '/avto-moto-zapchasti/',
  },
  {
    name: 'Детям',
    icon: footer2,
    link: '/detskie-tovary/',
  },
  {
    name: 'Дом',
    icon: footer1,
    link: '/dom-i-interer/',
  },
  {
    name: 'Дача',
    icon: footer3,
    link: '/tovary-dlya-dachi/',
  },
  {
    name: 'Красота',
    icon: footer5,
    link: '/parfyumeriya-i-kosmetika/',
  },
  {
    name: 'Спорт',
    icon: footer6,
    link: '/tovary-dlya-sporta-i-turizma/',
  },
  {
    name: 'Ремонт',
    icon: footer7,
    link: '/remont-i-otdelka/',
  },
  {
    name: 'Скидки дня',
    icon: footer8,
    link: '/promo/sale/',
  },
  {
    name: 'Промокоды',
    icon: footer6,
    link: '/promokody/',
  },
  {
    name: 'Все категории',
    icon: footer2,
    link: '/catalog/',
  },
]);
const shops = {
  title: 'Магазинам',
  links: [
    {
      name: 'Подключить магазин',
      to: 'https://biz.price.ru/welcome',
    },
    {
      name: 'Разместить рекламу',
      to: 'https://biz.price.ru/welcome',
    },
    {
      name: 'Правила размещения',
      to: 'https://biz.price.ru/welcome/price',
    },
  ],
};
const consumer = {
  title: 'Покупателям',
  links: [
    {
      name: 'Оплата и доставка',
      to: '/oplata-i-dostavka/',
    },
    {
      name: 'Обмен и возврат товара',
      to: '/obmen-vozvrat-garantiya/',
    },
    {
      name: 'Как оформить заказ',
      to: '/kak-oformit-zakaz/',
    },
  ],
};
const company = {
  title: 'Компания',
  links: [
    {
      name: 'О компании',
      to: '/about/',
    },
    {
      name: 'Контакты',
      to: '/contacts/',
    },
    {
      name: 'Блог',
      to: 'https://price.ru/blog/',
    },
    {
      name: 'Вконтакте',
      to: 'https://vk.com/price_ru_vk',
      icon: '/static/images/icon/vk-white.svg',
    },
  ],
};

const partners = {
  title: 'Партнёрам',
  links: [
    {
      name: 'Товарные виджеты',
      to: 'https://advertising.price.ru/partnerprice',
    },
    {
      name: 'Партнерские ссылки',
      to: 'https://advertising.price.ru/partnerprice',
    },
    {
      name: 'Товарные фиды',
      to: 'https://advertising.price.ru/partnerprice',
    },
  ],
};
const actualYear = new Date().getFullYear();

const sendAnalitics = (target: HTMLAnchorElement) => {
  if (target.href === 'https://price.ru/blog/') {
    // if ($ymAnyEvent instanceof Function) {
    $ymAnyEvent('reachGoal', 'blog_footer');
    // }
  }
};
const goTop = () =>
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
const throttleScroll = useThrottleFn(isShowTop, 20);

onMounted(() => {
  document.addEventListener('scroll', throttleScroll, { passive: true });
});
onBeforeUnmount(() => {
  document.removeEventListener('scroll', throttleScroll);
});
</script>
<style scoped lang="scss">
footer {
  background: $achromatic-black;
  margin-top: 48px;
  @include md-block {
    margin-top: 64px;
  }
  @include lg-block {
    margin-top: 80px;
  }

  .footer-container {
    padding-top: 16px;
    padding-bottom: 66px;
    @include sm-block {
      padding-top: 20px;
      padding-bottom: 70px;
    }
    @include lg-block {
      padding-top: 40px;
      padding-bottom: 70px;
    }
    @include xl-block {
      padding-bottom: 40px;
    }
  }

  .bottom {
    @include sm-block {
      @include row-flex();
      justify-content: space-between;
    }

    .column-wrapper {
      border-style: solid;
      border-color: #5f6369;
      border-width: 1px 0 0 0;
      padding: 16px 0 16px 0;
      @include col();
      @include size(24);
      @include sm-block {
        & {
          border-style: none;
          padding: 20px 0 20px 0;

          &:first-child,
          &:nth-child(2) {
            padding-top: 0;
          }

          &:last-child,
          &:nth-last-child(2) {
            margin-bottom: 0;
            padding-bottom: 0;
          }
        }
        @include size(12);
      }
      @include md-block {
        & {
          margin-bottom: 0;
          padding-bottom: 0;
          padding-top: 0;
        }
        @include size(6);
      }
      @include lg-block {
        & {
          margin-bottom: 0;
          padding-bottom: 0;
        }
        @include size(5);
      }
    }
  }

  .go-top {
    display: none;
    background: url('/static/images/icon/go-top.svg') center / contain no-repeat;
    width: 64px;
    height: 64px;
    position: fixed;
    font-size: 7px;
    cursor: pointer;
    transition: opacity 0.3s ease;
    bottom: 100px;
    right: 40px;
    opacity: 0;
    pointer-events: none;
    z-index: 85;
    @include xl-block {
      display: initial;
    }

    &.show {
      pointer-events: auto;
      opacity: 1;
    }
  }

  .copyright {
    color: $achromatic-disabled;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-style: solid;
    border-color: #5f6369;
    border-width: 1px 0 0 0;
    padding-top: 24px;
    @include sm-block {
      margin-top: 24px;
    }
    @include md-block {
      flex-direction: row;
      gap: 40px;
    }
    @include lg-block {
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
      margin-top: 32px;
      padding-top: 32px;
    }
    @include xl-block {
    }

    .age {
      background: $achromatic-disabled;
      padding: 0 0 2px 0;
      border-radius: 4px;
      color: $achromatic-black;
      line-height: 16px;
      vertical-align: middle;
      width: fit-content;
      margin-left: 2px;
      @include sm-block {
        padding: 1px 4px 0;
        margin-top: 0;
        margin-left: 8px;
      }
    }

    .mobile-br {
      font-size: 0;
      height: 0;
      display: block;
      @include md-block {
        font-size: inherit;
        display: inline;
      }
    }

    &-left-group {
      display: flex;
      flex-direction: column;
      gap: 12px;
      @include md-block {
        flex-direction: row;
        gap: 40px;
      }
      @include lg-block {
        gap: 80px;
      }
    }
  }

  .hide-mobile {
    display: none;
    @include sm-block() {
      display: initial;
    }
  }

  .date-company {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    @include sm-block {
      svg {
        margin-left: 8px;
      }
    }
  }

  .coma {
    @include sm-block {
      margin-right: 8px;
    }
  }

  :deep(
      .column-wrapper
        .column-items
        .column-item[data-v-ee578d43]:not(:first-child)
    ) {
    margin-top: 12px;
  }
}
</style>
